const e = {
  smart_event_calendar_header: {
    styled_button_text: "Create operation",
    styled_text_title_text: "Smart event calendar"
  }
}, t = {
  basic_info_fields: {
    form_item_label: "Name",
    form_item_msg: "The plan name is required.",
    form_item_placeholder: "Plan name",
    form_label_crop_cycle: "Crop cycle",
    form_label_estimated_planting_date: "Estimated planting date",
    form_rule_msg_estimated_planting_date: "The estimated planting date is required.",
    form_rules_msg_crop_cycle: "The crop cycle is required.",
    select_crop_cycle_placeholder: "Select crop cycle"
  },
  basic_info_form: {
    label_crop_cycle: "Crop cycle",
    label_estimated_planting_date: "Estimated planting date",
    select_crop_cycle_placeholder: "Select crop cycle",
    text_input_plan_label: "Name",
    text_input_plan_name: "plan_name",
    text_input_plan_placeholder: "Plan A"
  },
  confirmation_dialog: {
    alert_cancel_text: "Cancel",
    alert_description: "Would you like to exit?",
    alert_ok_text: "Yes, continue and exit",
    alert_title: "You will lose the data entered.",
    chevron_left_icon: "New plan"
  },
  delete_smart_plan_dialog: {
    alert_cancel_text: "Cancel",
    alert_description: "Would you like to delete this smart plan?",
    alert_message_cancel: "Operation Cancelled",
    alert_message_success: "Smart plan deleted successfully",
    alert_ok_text: "Yes",
    alert_title: "Delete smart plan"
  },
  list_filter: {
    button_apply_text: "Apply",
    button_cancel_text: "Cancel",
    button_clear_selection_text: "Clear selection"
  },
  operation_collapse: {
    info_group_description: "Soil treatment",
    info_group_hectares_description: "ha/sample",
    info_group_hectares_title: "Hectares/sample",
    info_group_inspection_group: "Inspection Group",
    info_group_sample_size_title: "Sample size per area",
    info_group_title: "Inspection group",
    operation_type_label: "SCOUTING"
  },
  operation_form: {
    button_cancel_text: "Cancel",
    button_create_operation_text: "Create operation",
    button_update_operation_text: "Update operation",
    criteria_msg: "The criteria is required.",
    input_name_placeholder: "Operation name",
    inspection_group_label_text: "Days after conclusion of previous activity",
    item_activity_msg: "The activity is required.",
    item_date_range_msg: "Date range is required.",
    item_days_msg: "The criteria days is required.",
    item_days_or_degress_msg: "The criteria days is required.",
    item_gdd_degrees_msg: "The criteria GDD value is required.",
    item_hectar_value_msg: "Hectar per area is required.",
    item_name_msg: "The operation name is required.",
    item_scounting_type_msg: "Point distribution is required.",
    label_criteria_text: "Criteria",
    label_name_text: "Name",
    parent_activity_label_text: "Activity to be considered",
    point_distribution_label_text: "Point distribution",
    radio_free_by_rate_text: "Hectares / sample",
    radio_free_sample_count_text: "Sample size per area",
    select_activity_placeholder: "Select",
    select_criteria_placeholder: "Select time range type",
    select_inspection_group_placeholder: "Select one or more inspection group",
    type_label_text: "Type: Scouting"
  },
  operation_list: {
    button_create_operation_text: "Create operation",
    list_title_text: "Operations"
  },
  operations_table: {
    calendar_icon_start_due_date_text: "START/DUE DATE",
    column_assignee_title: "Assignee",
    column_criteria_title: "Criteria",
    column_operation_name_title: "Operation name",
    column_region_field_title: "Property/Field",
    column_status_title: "Status",
    column_type_title: "Type",
    columns_start_date_title: "Start date",
    double_user_icon_assignee_text: "Assignee(s)",
    info_icon_details_text: "Details",
    label_deleted_text: "Delete",
    light_gray_tag_hectares_sample_text: "Hectares/sample:",
    light_gray_tag_inspection_group_text: "Inspection group:",
    regular_text_region_area_text: "Region / Area: 4",
    field_not_found: "Talhão não encontrado"
  },
  region_tree_select: {
    props_selected_area_placeholder: "Please select"
  },
  search_input: {
    input_search_placeholder: "Search",
    tooltip_search_title: "Search"
  },
  smart_plan_subheader: {
    linked_header_operation_tasks_text: "Operations tasks",
    linked_header_plans_text: "Plans",
    pages_items_key_1_label: "10 / page",
    pages_items_key_2_label: "25 / page",
    pages_items_key_3_label: "50 / page",
    space_pages_text: "Pages",
    space_status_text: "Status",
    status_items_key_1_label: "All tasks",
    status_items_key_2_label: "Scheduled",
    status_items_key_3_label: "Delayed",
    status_items_key_4_label: "Completed"
  }
}, a = {
  create_operation: {
    button_action_create_op_plan_text: "Create new operation plan",
    button_action_create_operation_text: "Create operation",
    drawer_create_operation_title: "Create new operation",
    empty_state_no_operation_description: "Click the below to create your first operation",
    empty_state_no_operation_title: "No operations were created for this plan",
    message_failed_registered: "Failed to record operations",
    the_operations: "The operations",
    does_not_have_schema: "do not have a related schema.",
    schema_not_found: "No schemas found for this crop in this workspace",
    message_success_registered: "Operations registered successfully. It could take a few minutes to be displayed on the Smart Event Calendar page",
    title_section_title: "Create and setup the operation plan"
  },
  create_plan: {
    control_steps_cancel_title: "Cancel",
    controle_steps_next_title: "Next",
    form_title_crop_cycle_text: "Basic information",
    title_section_crop_cycle_title: "What is the name and the crop cycle of the plan?"
  },
  fields: {
    control_step_second_next: "Next",
    control_steps_first_title: "Back",
    field_required_box_fields_name_msg: "* The fields are required.",
    title_section_title: "Select the fields"
  },
  smart_calendar: {
    button_link_text: "New plan",
    empty_state_description: "Click the below to create your first operation plan",
    empty_state_title: "No operation plan was created"
  }
}, _ = {
  create_plan: {
    form_title: "Basic information",
    title: "What is the name and the crop cycle of the plan?"
  }
}, i = {
  atoms: e,
  molecules: t,
  sections: a,
  smart_plan: _
};
export {
  e as atoms,
  i as default,
  t as molecules,
  a as sections,
  _ as smart_plan
};
